import { conforms } from "lodash";

// API URL's for Login
const POST_LOGIN_URL = "admin/api/auth/login";
const POST_VALIDATE_TOKEN = "/admin/api/auth/validateToken";
const POST_LOGOUT = "/admin/api/auth/logout";
const POST_FORGOT_PASSWORD= "admin/api/user/forgot-password"
const POST_VERIFY_OTP= "admin/api/user/verify-otp";
const POST_RESET_PASSWORD= "admin/api/user/reset-password"

// API URL's for USER MANAGEMENT
// Users
const GET_ALL_USERS = "admin/api/users/getAllUsers";
const GET_USERDATA_BY_ID = (id) => `admin/api/users/${id}`;
const UPDATE_USERDATA = (userId) => `admin/api/users/${userId}`;
const CREATE_USER = "admin/api/users";

// Roles
const GET_ROLES_DATA =
  "admin/api/rolePermissions/getAllRolePermissions?page=0&size=30";
const CREATE_ROLE = "admin/api/rolePermissions";
const GET_ROLE_BY_ID = (roleId) => `admin/api/rolePermissions/${roleId}`;
const UPDATE_ROLE_BY_ID = (roleId) => `admin/api/rolePermissions/${roleId}`;

// Modules
const GET_ALL_MODULES = "admin/api/modules?page=0&size=40";
const CREATE_MODULE = "admin/api/modules";
const UPDATE_MODULE_BY_ID = (id) => `admin/api/modules/${id}`;

// Operations
const GET_ALL_OPERATIONS = "admin/api/operations?page=0&size=40";

// API URL's for Customers
const GET_ALL_CUSTOMERS = "customer/api/getAllCustomers";
const GET_ALL_CUSTOMERS_ID_NAME_MAIL_CURRENCY = "customer/api/all";
const GET_CUSTOMERS_COUNT_DATA = "customer/api/counts";
const UPDATE_CUSTOMER_DATA_BY_ID = (id) =>
  `customer/api/updateCustomer?customerId=${id}`;
const GET_CUSTOMER_BY_ID = (id) =>
  `customer/api/getCustomerById?customerId=${id}`;
const CREATE_CUSTOMER = "customer/api/saveCustomer";
const CREATE_CUSTOMER_ADDRESS_BY_ID = (id) =>
  `customer/api/saveAddress?customerId=${id}&subscriptionId=100`;
const UPDATE_CUSTOMER_ADDRESS_BY_ID = (id) =>
  `customer/api/updateAddress?customerId=${id}&subscriptionId=100`;
const GET_ALL_CUSTOMERS_BY_STATUS = "customer/api/getActiveORInactiveCustomers";

// API URL's for contacts
const GET_ALL_CONTACTS = "/contact/api/getContacts";
const GET_CONTACTS_COUNT_DATA =
  "/contact/api/count/allContacts";
const UPDATE_CONTACT_DATA_BY_ID = (id) =>
  `/contact/api/update/${id}`;
const GET_CONTACT_BY_ID = (id) => `/contact/api/get/${id}`;
const CREATE_CONTACT = "/contact/api/saveContact";
const UPDATE_CONTACT_STATUS = (id, status) => `/contact/api/${id}/status/${status}`;
const GET_ALL_VENDORS_LIGHT_API = "/vendor/all";
const GET_ALL_CUSTOMERS_LIGHT_API = "/customer/api/all";



// API URL's for Employees  
const GET_ALL_EMPLOYEES = "employee/get-all";
const GET_ALL_EMPLOYEES_NAME_ID_MAIL = "employee/all";
const GET_EMPLOYEE_COUNT = "employee/counts";
const GET_EMPLOYEE_BY_ID = (id) => `employee/${id}`;
const UPDATE_EMPLOYEE_BY_ID = (id) => `employee/update/${id}`;
const CREATE_EMPLOYEE = "employee/save";

// API URL's for projects
const GET_ALL_PROJECTS = "/project/api/getAllProjectsByStatusAndSearchKey";
const GET_ALL_PROJECTS_ID_NAME = (id) =>
  `project/api/getAllProjects?subscriptionId=100&employeeId=${id}`;
const GET_ALL_PROJECTS_ID_NAMES =`project/api/getAllProjects?subscriptionId=100`
const GET_ALL_PROJECTS_BY_STATUS =
  "project/api/getCountStatus?subscriptionId=100";
const GET_PROJECT_BY_ID = (id) =>
  `project/api/getProjectByProjectId/${id}?subscriptionId=100`;
const UPDATE_PROJECT_BY_ID = (id) =>
  `project/api/updateProject/${id}?subscriptionId=100`;
const CREATE_PROJECT = "project/api/saveProject";
const GET_ALL_ASSIGNMENTS_ID_NAMES = (eId, pId) =>
  `/assignments/api/all?employeeId=${eId}&projectId=${pId}`;

// API URL's for Assignments
const GET_ASSIGNMENTS_COUNT_DATA = "assignments/api/count";
const GET_ALL_ASSIGNMENTS_ID_NAME = "/assignments/api/all";
const GET_ALL_ASSIGNMENTS = "assignments/api/search";
const CREATE_ASSIGNMENT = "assignments/api";
const GET_ASSIGNMENT_BY_ID = (id) => `assignments/api/${id}`;
const UPDATE_ASSIGNMENT_BY_ID = (id) => `assignments/api/${id}`;

// Timesheet
const GET_ALL_TIMESHEET = "/timesheet";
const GET_ALL_TIMESHEETS="/timesheet/all-timesheets"
const GET_TIMESHEET_COUNT = (id) =>
  `timesheet/counts?subscriptionId=100&employeeId=${id}`;
const GET_ALL_COUNTS="/timesheet/adminCount";
const TIMESHEET_APPROVER = (timesheetId) => `/timesheet/approve/${timesheetId}`;
const GET_EMPLOYEE_TIMESHEET = (id) => `/timesheet/employee/${id}`;
const GET_ALL_TIMESHEETS_BY_SEARCH = `/timesheet/search`;
const GET_ALL_TIMESHEETS_BY_ADMIN =   `/timesheet/adminAll`;
const GET_TIMESHEET_BY_ID = (id) => `/timesheet/${id}`;
const PUT_TIMESHEET_UPDATE = (id) => `/timesheet/update/${id}`;
const POST_TIMESHEET_SUBMIT = `/timesheet/submit`;
const POST_EMPLOYEE_TIMESHEET_REJECT = (id) => `/timesheet/reject/${id}`;
const GET_MANAGER_EMPLOYEES_LIST =(id) =>`/timesheet/employees?employeeId=${id}&subscriptionId=100`

// Invoices
const GET_PROJ_ASSIGN_BY_EMPID = "invoices/projectAssignmentDetails";
const GET_TIMESHEET_UNITS_PAYRATE = "invoices/timesheetDate";
const CREATE_INVOICE = "invoices";
const GET_ALL_INVOICES = "invoices/all";
const GET_INVOICE_BY_ID = (id) => `/invoices/${id}`;
const UPDATE_INVOICE = (id) => `/invoices/updateInvoice/${id}`;
const GET_INVOICE_COUNT = "invoices/invoiceCount";
//expensive-payable
const CREATE_PAYMENT = "billing/api/payable/create";
const GET_PAYMENT_BY_ID = (id) => `billing/api/payable/getById/${id}`;
const GET_ALL_PAYMENTS = "/billing/api/payable/getAll";
const UPDATE_PAYMENT_BY_ID = (id) => `billing/api/payable/update/${id}`;
const DELETE_PAYMENT_BY_ID = (id) => `billing/api/payable/delete/${id}`;
const GET_PAYMENTS_COUNT = "billing/api/payable/counts";

const CREATE_RECEIVABLE = "billing/api/receivable/create";
const GET_RECEIVABLE_BY_ID = (id) => `billing/api/receivable/getBy/${id}`;
const GET_ALL_RECEIVABLES = "billing/api/receivable/getAll";
const UPDATE_RECEIVABLE_BY_ID = (id) => `billing/api/receivable/update/${id}`;
// const DELETE_RECEIVABLE_BY_ID = (id) => `billing/api/receivable/delete/${id}`;
const GET_RECEIVABLES_COUNT = "/billing/api/payable/counts";

// Tickeing module
const CREATE_TICKET = "/tickets/api/create";
const GET_ALL_TICKETS = "/tickets/api/getAll";
const UPDATE_TICKET = (id) => `api/tickets/${id}`;
const GET_TICKET_BY_ID = (id) => `api/tickets/${id}`;
const DELETE_TICKET = (id) => `api/tickets/${id}`;

//Vendors
const GET_ALL_VENDORS = "/vendor/globalSearch";
const GET_ALL_COUNT_VENDORS = "vendor/counts";
const CREATE_VENDOR = "/vendor/create";
const GET_VENDOR_BY_ID = (vendorId) => `vendor/${vendorId}`;
const UPDATE_VENDOR_DATA_BY_ID = (vendorId) =>
  `vendor/UpdateVendor/${vendorId}`;
const GET_ACTIVE_INACTIVE_VENDORS =(vendorId) =>
  "vendor/getActiveORInactiveVendor/100";
const DELETE_VENDOR = (vendorId) => `vendor/DeleteVendor/${vendorId}`;

//contacts
// const CREATE_CONTACTS="/contact/api/saveContact";
// const GET_ALL_CONTACTS = "/contact/api/getContacts";



// Certifications module
const CREATE_CERTIFICATE = "/internship/create";
const CREATE_BULK_CERTIFICATES = "/internship/load";
const GET_ALL_CERTIFICATES = "/internship/getAll";
const GET_CERTIFICATE_BY_ID = (id) => `/internship/getById/${id}`;
const UPDATE_CERTIFICATE_BY_ID = (id) => `/internship/updateById/${id}`;
const CERTIFICATES_COUNT = "/internship/count";
const FILE_UPLOAD= "/fileservice/api/files/upload";

//TEMPLATE
const CREATE_TEMPLATE = "/recruitment/api/template/create";
const GET_ALL_TEMPLATE = "/recruitment/api/template/getAll";
const GET_TEMPLATES_COUNT = "/recruitment/api/template/count";
const UPDATE_TEMPLATE_BY_ID = (id) => `/recruitment/api/template/update/${id}`;
const GET_TEMPLATE_BY_ID = (id) => `/recruitment/api/template/getById/${id}`;
const PUT_TEMPLATE_STATUS_ID = (id, status) => `/recruitment/api/template/${id}/status?status=${status}`;

//Recritment Job posting

const CREATE_JOB_POST= "/recruitment/api/jobs/create";
const UPDATE_JOB_BY_ID = (id) => `/recruitment/api/jobs/update/${id}`;
const GET_ALL_JOBS="/recruitment/api/jobs/getAll";
const TOTAL_JOB_COUNT="/recruitment/api/jobs/getAllJobsCount";
const GET_STATUS_JOBS_ID =(id,status) =>`/recruitment/api/jobs/setJobStatus?status=${status}&id=${id}` 
const JOBS_GET_BY_ID = `/recruitment/api/jobs/getById`;
const GET_ALL_CANDIDATES = "/recruitment/api/candidates/all";
const VIEW_CANDIDATE_BY_ID = (candidateId ) =>`/recruitment/api/candidates/getById/${candidateId}`
const CREATE_CANDIDATE_POST= "/recruitment/api/candidates/create";
const CANDIDATE_APPLY_FOR_JOB="/recruitment/api/candidates/apply";
const CANDIDATES_GET_BY_ID =(id) => `/recruitment/api/candidates/getById/${id}` 
const CANDIDATE_TOTAL_COUNT= `/recruitment/api/candidates/evaluationCounts`
const PUT_CANDIDATE_STATUS= (id, status)=>`/recruitment/api/candidates/${id}/status/${status}`;
const GET_JOB_BY_ID= (id) =>`/recruitment/api/jobs/getJobById/${id}`;

//recuirement-interview-landing screen
const GET_ALL_INTERVIEWS ="/recruitment/api/interview/allInterviews"
const CREATE_INTERVIEWS = "/recruitment/api/interview/create";
const UPDATE_INTERVIEWS_BY_ID = (id) =>`/recruitment/api/interview/update/${id}`;
const GET_ALL_CANDIDATES_LIGHT =  `/recruitment/api/candidates/candidatesLightApi`;

//recuirement-resourcepool
const GET_ALL_RESOURSEPOOL="/recruitment/api/interview/allResources";




export {
  POST_LOGIN_URL,
  POST_FORGOT_PASSWORD,
  POST_VERIFY_OTP,
  POST_RESET_PASSWORD,
  GET_ALL_USERS,
  GET_USERDATA_BY_ID,
  UPDATE_USERDATA,
  CREATE_USER,
  GET_ROLES_DATA,
  GET_ROLE_BY_ID,
  GET_ALL_MODULES,
  GET_ALL_OPERATIONS,
  UPDATE_ROLE_BY_ID,
  CREATE_ROLE,
  CREATE_MODULE,
  UPDATE_MODULE_BY_ID,
  GET_ALL_CUSTOMERS,
  GET_CUSTOMERS_COUNT_DATA,
  UPDATE_CUSTOMER_DATA_BY_ID,
  GET_CUSTOMER_BY_ID,
  CREATE_CUSTOMER,
  GET_ALL_CUSTOMERS_ID_NAME_MAIL_CURRENCY,
  CREATE_CUSTOMER_ADDRESS_BY_ID,
  UPDATE_CUSTOMER_ADDRESS_BY_ID,
  GET_ALL_CUSTOMERS_BY_STATUS,
  GET_ALL_CONTACTS,
  GET_CONTACTS_COUNT_DATA,
  UPDATE_CONTACT_DATA_BY_ID,
  GET_CONTACT_BY_ID,
  CREATE_CONTACT,
  GET_ALL_PROJECTS,
  GET_ALL_PROJECTS_BY_STATUS,
  GET_PROJECT_BY_ID,
  UPDATE_PROJECT_BY_ID,
  GET_ALL_PROJECTS_ID_NAME,
  GET_ALL_PROJECTS_ID_NAMES,
  GET_ALL_ASSIGNMENTS_ID_NAMES,
  CREATE_PROJECT,
  GET_ASSIGNMENTS_COUNT_DATA,
  GET_ALL_ASSIGNMENTS_ID_NAME,
  GET_ALL_ASSIGNMENTS,
  GET_ALL_EMPLOYEES,
  CREATE_ASSIGNMENT,
  GET_ASSIGNMENT_BY_ID,
  UPDATE_ASSIGNMENT_BY_ID,
  GET_EMPLOYEE_BY_ID,
  GET_ALL_EMPLOYEES_NAME_ID_MAIL,
  GET_EMPLOYEE_COUNT,
  UPDATE_EMPLOYEE_BY_ID,
  CREATE_EMPLOYEE,
  GET_ALL_TIMESHEET,
  GET_ALL_TIMESHEETS,
  TIMESHEET_APPROVER,
  GET_EMPLOYEE_TIMESHEET,
  GET_TIMESHEET_COUNT,
  GET_ALL_TIMESHEETS_BY_SEARCH,
  GET_TIMESHEET_BY_ID,
  POST_EMPLOYEE_TIMESHEET_REJECT,
  PUT_TIMESHEET_UPDATE,
  POST_TIMESHEET_SUBMIT,
  GET_PROJ_ASSIGN_BY_EMPID,
  GET_TIMESHEET_UNITS_PAYRATE,
  GET_ALL_TIMESHEETS_BY_ADMIN,
  GET_ALL_COUNTS, 
  POST_VALIDATE_TOKEN,
  POST_LOGOUT,
  CREATE_INVOICE,
  UPDATE_INVOICE,
  GET_INVOICE_BY_ID,
  GET_ALL_INVOICES,
  CREATE_PAYMENT,
  GET_ALL_PAYMENTS,
  GET_PAYMENT_BY_ID,
  UPDATE_PAYMENT_BY_ID,
  CREATE_RECEIVABLE,
  UPDATE_RECEIVABLE_BY_ID,
  GET_ALL_RECEIVABLES,
  GET_RECEIVABLE_BY_ID,
  // DELETE_RECEIVABLE_BY_ID,
  GET_PAYMENTS_COUNT,
  GET_RECEIVABLES_COUNT,
  GET_INVOICE_COUNT,
  CREATE_TICKET,
  UPDATE_TICKET,
  GET_TICKET_BY_ID,
  DELETE_TICKET,
  GET_ALL_TICKETS,
  CREATE_CERTIFICATE,
  CREATE_BULK_CERTIFICATES,
  GET_ALL_CERTIFICATES,
  GET_CERTIFICATE_BY_ID,
  UPDATE_CERTIFICATE_BY_ID,
  CERTIFICATES_COUNT,
  FILE_UPLOAD,
  GET_ALL_COUNT_VENDORS,
  CREATE_TEMPLATE,
  GET_ALL_TEMPLATE, 
  UPDATE_TEMPLATE_BY_ID,
  GET_TEMPLATES_COUNT,
  GET_TEMPLATE_BY_ID,
  PUT_TEMPLATE_STATUS_ID,
  GET_ALL_VENDORS,
  GET_VENDOR_BY_ID,
  UPDATE_VENDOR_DATA_BY_ID,
  CREATE_VENDOR,
  DELETE_VENDOR,
  GET_ACTIVE_INACTIVE_VENDORS,
  CREATE_JOB_POST,
  GET_ALL_JOBS,
  TOTAL_JOB_COUNT,
  UPDATE_JOB_BY_ID,
  JOBS_GET_BY_ID,
  GET_ALL_CANDIDATES,
  VIEW_CANDIDATE_BY_ID,
  GET_STATUS_JOBS_ID,
  PUT_CANDIDATE_STATUS,
  CANDIDATE_TOTAL_COUNT,
  CANDIDATES_GET_BY_ID,
  CREATE_CANDIDATE_POST,
  CANDIDATE_APPLY_FOR_JOB,
  GET_ALL_INTERVIEWS,
  GET_ALL_RESOURSEPOOL, 
  CREATE_INTERVIEWS,
  UPDATE_INTERVIEWS_BY_ID,
  GET_ALL_CANDIDATES_LIGHT,
  GET_MANAGER_EMPLOYEES_LIST,
  UPDATE_CONTACT_STATUS,
  GET_ALL_VENDORS_LIGHT_API,
  GET_ALL_CUSTOMERS_LIGHT_API,  
  GET_JOB_BY_ID,
 

};
